import React, { useState } from 'react';
import { PlayIcon } from 'lucide-react';
import type { CustomerStory } from '../../types/story';
export function VideoRow({
  stories
}: {
  stories: CustomerStory[];
}) {
  const [pending, setPending] = useState<string | null>(null);
  if (stories.length === 0) return null;
  return <section className="w-full bg-canvas-warm py-20" aria-labelledby="videos-heading" data-id="element-1648" data-mp="2wllxn6p2247t">
      <div className="mx-auto max-w-shell px-6" data-id="element-1649" data-mp="2immay4l3rzea">
        <h2 id="videos-heading" className="display text-[30px] font-semibold text-ink sm:text-[40px]" data-id="element-1650" data-mp="2ikt3in2o1b58">
          Hear it from the owners
        </h2>
        <ul className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-1651" data-mp="28ogazsiux3c2">
          {stories.map(story => <li key={story.slug} data-id="element-1652" data-mp="2dmrl84d2dfut">
              <button type="button" onClick={() => setPending(story.slug)} aria-label={`Play video: ${story.owner}, ${story.business}`} className="group relative block w-full overflow-hidden rounded-[12px] text-left" data-id="element-1653" data-mp="2dnt7z63fzqsd">
                <img src={story.image} alt="" loading="lazy" className="h-[220px] w-full object-cover" data-id="element-1654" data-mp="1t15ud06j6pv9" />
                <span className="absolute inset-0 bg-ink/25 transition-colors duration-150 ease-out group-hover:bg-ink/35" aria-hidden="true" data-id="element-1655" data-mp="1o2um2tvvwnf5" />
                <span className="absolute left-1/2 top-1/2 flex h-14 w-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-ink transition-transform duration-150 ease-out group-hover:scale-105" data-id="element-1656" data-mp="1xtfiqbrzzhvf">
                  <PlayIcon className="ml-0.5 h-5 w-5 fill-current" aria-hidden="true" data-id="element-1657" data-mp="155jnzclzo01a" />
                </span>
                {story.video && <span className="absolute bottom-3 right-3 rounded-[6px] bg-ink/80 px-2 py-0.5 text-[12px] font-medium tabular-nums text-white" data-id="element-1658" data-mp="1j1wvpu0q0n2k">
                    {story.video.duration}
                  </span>}
              </button>
              <p className="mt-4 text-[15px] font-semibold text-ink" data-id="element-1659" data-mp="2pjbp2f7wetjv">{story.owner}</p>
              <p className="mt-0.5 text-[14px] text-ink-muted" data-id="element-1660" data-mp="1n7qgr0n38vc9">{story.business}</p>
              {pending === story.slug && <p role="status" className="mt-2 text-[13px] text-ink-muted" data-id="element-1661" data-mp="1s4gxlq6pvuyq">
                  This video is being prepared and will be available soon.
                </p>}
            </li>)}
        </ul>
      </div>
    </section>;
}